<template>
<div>
    <!-- <headerComponent/> -->
    <div class="pageContainer"  ref="container">
      <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
          <slide v-for="image in images" :key="image">  
              <img :src="require(`${image}`)" alt="carousel image">  
          </slide>  
      </carousel>   -->

      <el-carousel :interval="3000" arrow="always" :height="carouselHeight" :autoplay="true" class="animate__animated animate__fadeInRight" width="100%">
        <el-carousel-item v-for="(image,index) in images" :key="index">
          <img :src="image.src" alt="carousel image" width="100%"  :height="carouselHeight">  
        </el-carousel-item>
      </el-carousel>
      <!-- 第一部分开始 解决方案 -->
      <first :obj="solutionInfo" v-if="JSON.stringify(solutionInfo) !== '{}'"/>
      <!-- 第一部分结束 -->

      <!-- 第二部分开始 生产-->
      <div  class = "bg carouselStyle" >
        <equipment :title="equipmentInfo.sub_name" :subTitle="equipmentInfo.name"/>
        <div style="width:1300px;margin:0 auto;height:740px"  v-animate-onscroll="'animate__animated animate__fadeInRight'">
          <div class="center-box">
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide class="box-slide" v-for="(item, index) in equipmentInfo.articles" :key="index">
                  <div class="card">
                      <img :src="item.thumb" alt="card image" class="carousel-card__image" style="height:600px">  
                      <div class="carousel-card__content">  
                        <h3 class="carousel-card__title" style="display:block;float:left;font-size:32px;color:#272a36;width:450px;text-align:left;font-weight:300">{{ item.title }}</h3>  
                      </div> 
                </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev" slot="button-prev">
                <img src="./images/arrowL.png" class="arrow_left">
            </div>
            <div class="swiper-button-next" slot="button-next">
              <img src="./images/arrowR.png" class="arrow_right">
            </div>
          </div>
        </div>
      </div>
      <!-- 第二部分结束 -->

      <!-- 第三部分开始 视频-->
      <div  class = "bgThird carouselStyle" v-if="JSON.stringify(videos) !== '{}'">
        <!-- <equipment/> -->
        <div style="width:1300px;margin:0 auto;position:relative" v-animate-onscroll="'animate__animated animate__fadeInLeft'">
          <div style="width:120px;float:left;">
            <img src="./images/vedioLeft.png" alt="" srcset="" width="100%"  style="margin:120px 0 0 0">
          </div>
          <div style="width:1100px;float:right;height:700px;margin:100px 0 0 0;">

            <div class="center-box">
              <swiper ref="mySwiperVideo" :options="swiperVideoOptions" @slideChange="onSlideChange">
                  <swiper-slide class="box-slide" v-for="(item, index) in videos.articles" :key="index">
                    <div class="card">
                        <video ref="videoElements" width="100%" height="700" @play="onVideoPlay(index)" :poster="item.thumb"   @pause="onVideoPause(index)"   @ended="onVideoEnded(index)" controls>  
                        <source :src="item.video_url" type="video/mp4">  
                        您的浏览器不支持 Video 标签。  
                      </video> 
                  </div>
                  </swiper-slide>
              </swiper>
              <div class="swiper-button-prevVideo" slot="button-prev">
                  <img src="./images/arrowLw.png" class="arrow_left videoL">
              </div>
              <div class="swiper-button-nextVideo" slot="button-next">
                <img src="./images/arrowLr.png" class="arrow_right videoR">
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <!-- 第三部分结束 -->
      <!-- 第四部分开始 -->
      <div class="containerOne" style="position:relative;width:100%;height:950px;">
      <!-- <img src="@/views/aboutUs/images/group01.png" alt="" srcset="" style="width:1458px;position:absolute;right:10px;z-index:1"> -->
       <img v-animate-onscroll="'animate__animated animate__fadeInLeft'" src="@/views/home/images/fourthFX.png" alt="" srcset="" style="width:1280px;position:absolute;z-index:3;left:0;top:45px">
       <div class="fourthTop" style="background:#fff;width:100%;height:260px;">
          <div style="background:#fff;width:1200px;height:260px;float:right" ref="box">
            <div class="logoContain">
            <span class="logoTit" style="left:75px">
              <countTo ref="year" :autoplay="false" :startVal='0' :endVal='1995' :duration='3000' separator=""></countTo>
            </span>
            <span class="logoWord" style="left:90px;"><countTo ref="year2" :autoplay="false" :startVal='0' :endVal='1995' :duration='3000' separator=""></countTo>年创立品牌</span>
          </div>

          <div class="logoContain">
            <span class="logoTit" style="left:85px"> 
              <countTo  ref="country" :startVal='0'  :autoplay="false" :endVal='27' :duration='3000' separator=""></countTo>
              </span>
            <span class="logoWord" style="left:40px;">销售遍布全球<countTo ref="country2" :autoplay="false" :startVal='0' :endVal='27' :duration='3000' separator=""></countTo>个国家</span>
          </div>

          <div class="logoContain">
            <span class="logoTit" style="left:60px"><countTo  ref="square" :startVal='10000'  :autoplay="false" :endVal='26000' :duration='3000' separator=""></countTo></span>
            <span class="logoWord" style="left:60px;"><countTo  ref="square2" :startVal='10000'  :autoplay="false" :endVal='26000' :duration='3000' separator=""></countTo>平花园式工业园区</span>
          </div>
          </div>
       </div>
          <div class="clearBoth"></div>
       <div class="fourthBottom" style="width:100%;height:690px;background:#272a36;border-bottom:3px solid #888">
          <div style="float:right">
          <div class="titleStyle">
            <span style="font-size:97px;font-weight:700">About</span>
          </div>

          <div class="subTitleStyle">
            <img src="@/views/solution/images/redRight.png" alt="" srcset="" style="width:23px;position:absolute;top:0;left:0">
              <span style="position:absolute;display:block;bottom:15px;font-size:18px;color:#fcfcfc;letter-spacing:1px;font-weight:300">{{aboutUsInfo.name}}</span>
          </div>
        </div>
        <div class="wordsOne"   v-animate-onscroll="'animate__animated animate__fadeInRight'">
          <span v-for="(item,index) in aboutUsInfo.articles.des" :key="index">{{item}} </span>
        </div>
       </div>
       
    </div>
    <!-- <div v-animate-onscroll.repeat="'animate__animated animate__zoomIn'">
          Animate_zoomIn
      </div> -->
    <div class="clearBoth"></div>
      <!-- 第四部分结束 -->

      <!-- 第五部分开始 新闻类信息-->
      <div style="background:#272a36" v-if="JSON.stringify(newsInfo) !== '{}'">
         <news :newsInfo = "newsInfo"/>
         <div style="width:1300px;margin:0 auto;height:500px;">
          <div class="leftFifth" style="width:760px;float:left;position:relative;color:#fff;cursor:pointer"  v-animate-onscroll="'animate__animated animate__fadeInLeft'" @click="toPath(newsInfo,'Detail')">
            <img :src="newsInfo?.articles[0]?.thumb" alt="" srcset="" width="100%">
            <div style="position:absolute;background:#272a36;width:100%;height:180px;left:0;bottom:0;opacity:0.9;z-index:5">
            </div>
            <div style="position:absolute;width:100%;height:180px;left:0;bottom:0;z-index:6;padding:30px 30px 0 5px;">
              <div class="dateStyle">
                <span class="big">{{curDay}}</span>
                <span class="small">{{curYear}}-{{curMonth}}</span>
              </div>
              <div class="fifthNews">
                <span class="title">{{newsInfo?.articles[0]?.title}}</span>
                <span class="content">{{newsInfo?.articles[0]?.des}}</span>
              </div>
            </div>
          </div>
          <div class="leftFifth" style="width:500px;float:right"  v-animate-onscroll="'animate__animated animate__fadeInRight'">
            <el-collapse v-model="activeName">
              <el-collapse-item v-for="(item,index) in newsInfoArr" :key="index" :title="item.title" :name="index" @mouseenter.native="hoverExpand(item,index)" @mouseleave.native="hoverClose(item)">
                <template slot="title">
                  <div class="blockFifth" @click="navigateTo(item)">
                    <span class="titFifth" style=""> {{item.title}}</span>
                    <span class="dateFifth" style="">{{item.create_time}}</span>
                  </div>    
                  <div class="clearBoth"></div>
                </template>
                <div class="desFifth" @click="navigateTo(item)" style="cursor:pointer">{{item.des}}</div>
              </el-collapse-item>
            </el-collapse>
          </div>
         </div>
         <div class="clearBoth"></div>
      </div>
   
      <!-- 第五部分结束 -->
      <!-- 第六部分开始 -->
      <div style="background:#fff" class="allLogo">
        <partners/>
        <div style="width:1300px;height:500px;margin:0 auto;">
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
              <div class="partnerImgTop clearfix">
                <img class="partnerImg show" style="position:absolute;width:100px;left:100px;top:50px;" src="./images/logo01.png" alt="" srcset="">
                <img class="partnerImg hide" style="position:absolute;width:100px;left:100px;top:50px;" src="./images/hoverlogo01.png" alt="" srcset="">
              </div>
            <!-- </kinesis-element> -->
          </div>
        <div class="clearfix" style="display: inline-block;width: 25%;" > 
         <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop imgColor">
            <img class="partnerImg show" style="position:absolute;width:130px;left:100px;top:60px;" src="./images/logo02.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:130px;left:100px;top:60px;" src="./images/hoverlogo02.png" alt="" srcset="">
          </div>
        <!-- </kinesis-element> -->
        </div>
        <div class="clearfix" style="display: inline-block;width: 25%;" > 
        <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop clearfix">
            <img class="partnerImg show" style="position:absolute;width:145px;left:100px;top:55px;" src="./images/logo03.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:145px;left:100px;top:55px;" src="./images/hoverlogo03.png" alt="" srcset="">
          </div>
          <!-- </kinesis-element> -->
          </div>
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop imgColor">
            <img class="partnerImg show" style="position:absolute;width:135px;left:100px;top:60px;" src="./images/logo04.png" alt="" srcset="">
<img class="partnerImg hide" style="position:absolute;width:135px;left:100px;top:60px;" src="./images/hoverlogo04.png" alt="" srcset="">
          </div>
            <!-- </kinesis-element> -->
            </div>
            <div class="clearfix" style="display: inline-block;width: 25%;" > 
               <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop imgColor">
            <img class="partnerImg show" style="position:absolute;width:150px;left:100px;top:45px;" src="./images/logo05.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:150px;left:100px;top:45px;" src="./images/hoverlogo05.png" alt="" srcset="">
          </div>
          <!-- </kinesis-element> --></div>
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop ">
            <img class="partnerImg show" style="position:absolute;width:135px;left:100px;top:45px;" src="./images/logo06.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:135px;left:100px;top:45px;" src="./images/hoverlogo06.png" alt="" srcset="">
          </div>
        <!-- </kinesis-element> --></div>
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop imgColor">
            <img class="partnerImg show" style="position:absolute;width:65px;left:120px;top:35px;" src="./images/logo07.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:65px;left:120px;top:35px;" src="./images/hoverlogo07.png" alt="" srcset="">
          </div> <!-- </kinesis-element> --></div>
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop clearfix">
            <img class="partnerImg show" style="position:absolute;width:160px;left:100px;top:45px;" src="./images/logo08.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:160px;left:100px;top:45px;" src="./images/hoverlogo08.png" alt="" srcset="">
          </div> <!-- </kinesis-element> --></div>
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop clearfix">
            <img class="partnerImg show" style="position:absolute;width:130px;left:100px;top:45px;" src="./images/logo09.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:130px;left:100px;top:45px;" src="./images/hoverlogo09.png" alt="" srcset="">
          </div> <!-- </kinesis-element> --></div>
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop imgColor">
            <img class="partnerImg show" style="position:absolute;width:70px;left:120px;top:45px;" src="./images/logo10.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:70px;left:120px;top:45px;" src="./images/hoverlogo10.png" alt="" srcset="">
          </div> <!-- </kinesis-element> --></div>
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop clearfix">
            <img class="partnerImg show" style="position:absolute;width:140px;left:100px;top:45px;" src="./images/logo11.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:140px;left:100px;top:45px;" src="./images/hoverlogo11.png" alt="" srcset="">
          </div> <!-- </kinesis-element> --></div>
          <div class="clearfix" style="display: inline-block;width: 25%;" > 
             <!-- <kinesis-element type="depth" :strength='30' > -->
          <div class="partnerImgTop imgColor">
            <img class="partnerImg show" style="position:absolute;width:85px;left:120px;top:35px;" src="./images/logo12.png" alt="" srcset="">
            <img class="partnerImg hide" style="position:absolute;width:85px;left:120px;top:35px;" src="./images/hoverlogo12.png" alt="" srcset="">
          </div>
            <!-- </kinesis-element> -->
          </div>
          
        </div>
      </div>
      <!-- 第六部分结束 -->

    </div>
</div>
</template>
<script>
import first from '@/views/home/components/first'
import equipment from '@/views/home/components/equipment'
import news from '@/views/home/components/news'
import partners from '@/views/home/components/partners.vue'
import { getIndex,cate } from '@/api/index.js'
// import { KinesisContainer, KinesisElement} from 'vue-kinesis'  
import countTo from 'vue-count-to';
// 引入Vue Carousel组件  
export default {
  name: 'App',
   components:{
    // headerComponent,
    first,
    equipment,
    news,
    partners,
    countTo,
    // KinesisContainer,
    // KinesisElement
  },
  data() {  
    return {  
      newsInfoArr:[],
      curYear:'',
      curMonth:'',
      curDay:'',
      newsInfo:{}, // 新闻类信息
      solutionInfo:{}, // 解决方案类信息
      equipmentInfo:{},// 生产类信息
      aboutUsInfo:{}, // 关于我们类信息
      activeName: '', // 控制折叠面板的展开状态 
      carouselHeight: '710px',
      indexArr: [],
      swiperOptions: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 2500
        },
        slidesPerView: 1.2, // 显示个数
        spaceBetween: 10,
        direction: 'horizontal',
        grabCursor: true,
        touchStartPreventDefault: false,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable:true
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperVideoOptions: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 2500
        },
        slidesPerView: 1, // 显示个数
        spaceBetween: 10,
        direction: 'horizontal',
        grabCursor: true,
        touchStartPreventDefault: false,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable:true
        // },
        navigation: {
          nextEl: '.swiper-button-nextVideo',
          prevEl: '.swiper-button-prevVideo'
        }
      },
     images: [  
        './images/carousel01.png',  
        './images/homeBanner01.png',
      ],
      imagesSec: [  
        { image: './images/sec01.png', title: '一体化全自动生产线' },  
        { image: './images/fifth01.png', title: '一体化全自动生产线 2' },  
        { image: './images/carousel01.png', title: '一体化全自动生产线 2' },  
        { image: './images/bgEquipment.png', title: '一体化全自动生产线 4' }
      ], 
      // videos:['./video/video01.mp4','./video/video02.mp4'],
      videos:{},
      yearType:true
    };  
  }, 

  methods:{
    cateEvent() {
        this.$nextTick(()=>{
            cate().then((res)=>{
                this.images = this.filterItemsByPath('/',res.data).banner
            })
        })
    },
    toPath(item,detail) {
      if(item && item.articles && item.articles.length>0) {
        let _path = item.path.replace('/#/','/')
        this.$router.push({path:_path+detail,query:{id:item.articles[0].id}});  
      }
      
    },
    hoverExpand(item,index) {  
      this.activeName = index; // 展开当前鼠标经过的面板  
    },  
    hoverClose(item) {  
      // 如果你想要在鼠标离开时总是关闭面板，可以设置 activeName 为空  
      // 如果你只想要在鼠标离开当前面板时关闭它，可以检查 activeName 是否等于当前面板的 name  
      if (this.activeName === item.title) {  
        this.activeName = ''; // 关闭当前面板  
      }  
    }, 
    navigateTo(item) {  
      this.$router.push({path:'/newsDetail',query:{id:item.id}});  
    },  
    handleChange(val) {  
      // 可以在这里处理折叠面板展开或折叠后的逻辑  
      console.log(val);  
    }, 
    onSlideChange() {  
      // 切换幻灯片时暂停所有视频  
      this.$refs.videoElements.forEach((video) => {  
        video.pause();  
      });  
    },  
    onVideoPlay(index) {  
      // 播放视频时停止轮播  
      this.autoplay = false;  
      this.$refs.mySwiperVideo.swiper.autoplay.stop();  
    },  
    onVideoPause(index) {  
      // 视频暂停时恢复轮播  
      this.autoplay = true;  
      this.$refs.mySwiperVideo.swiper.autoplay.start();  
    },  
    onVideoEnded(index) {  
      // 视频结束时恢复轮播  
      this.autoplay = true;  
      this.$refs.mySwiperVideo.swiper.autoplay.start();  
    },
    getIndexEvent() {
      this.$nextTick(()=>{
            getIndex().then((res)=>{
                this.indexArr = res.data
                // 处理解决方案类信息 - 开始
                this.solutionInfo  = this.filterItemsByPath('/#/solution',res.data)
                // 处理解决方案类信息 - 结束
                // 处理生产类信息-开始
                this.equipmentInfo = this.filterItemsByPath('/#/equipment',res.data)
                // 处理生产类信息-结束

                // 处理生产类信息-开始
                this.aboutUsInfo = this.filterItemsByPath('/#/aboutUs',res.data)
                // 处理生产类信息-结束

                // 处理视频类信息-开始
                this.videos = this.filterItemsByPath('/#/video',res.data)
                // 处理视频类信息-结束

                // 处理新闻类信息-开始
                this.newsInfo = this.filterItemsByPath('/#/news',res.data) // 新闻类信息
                if(this.newsInfo && this.newsInfo.articles && this.newsInfo.articles.length>0 && this.newsInfo.articles[0].create_time) {
                  const _date = new Date(this.newsInfo.articles[0].create_time)
                  this.curYear = _date.getFullYear()
                  this.curMonth = _date.getMonth()+1
                  this.curDay = _date.getDate()

                  this.newsInfoArr = this.newsInfo.articles.slice(1)
                }
                // 处理新闻类信息-结束
                
            })
        })
    },
    getHeight() {
      let windowWidth = window.innerWidth;  
      if(windowWidth > 1450) {
        // console.log()
      } else {
        windowWidth = 1450
      }
      const newHeight = `${windowWidth * 1080 / 2880}px`;  
      this.carouselHeight = newHeight;
    },
    handleScroll() {
      const boxRect =  this.$refs.box.getBoundingClientRect();
      if (boxRect.top <= window.innerHeight && boxRect.bottom >= 0&& this.yearType) {
        this.yearType = false;
        // 当box进入视窗时触发动画
        this.startAnimation();
      }
    },
    startAnimation() {
      this.$refs.year.start();
      this.$refs.country.start()
      this.$refs.square.start();
      this.$refs.year2.start();
      this.$refs.country2.start()
      this.$refs.square2.start();
      // 这里编写触发动画的逻辑
    },
    filterItemsByPath(path,arr) {
      let _arr = []
      let newArr = []
      _arr = arr
      newArr =  _arr.filter(item => item.path === path);
      if (newArr.length > 0) {
        return newArr[0]; // 只取第一个匹配的对象
      } else {
        return {}; // 如果没有匹配的对象，返回空对象
      }
  }
  },
  watch: {  
    autoplay(newVal) {  
      if (newVal) {  
        this.$refs.mySwiperVideo.swiper.autoplay.start();  
      } else {  
        this.$refs.mySwiperVideo.swiper.autoplay.stop();  
      }  
    }  
  },
  mounted() {  
    this.getIndexEvent()
    this.cateEvent()
    window.addEventListener('scroll',this.handleScroll);
    this.$nextTick(()=>{
      this.getHeight()
      // 可以在 mounted 挂载之后获取实际容器高度  
      window.addEventListener('resize', () => {  
        // this.carouselHeight = `${document.documentElement.clientHeight * 0.8}px`;  
        this.getHeight()
        
      }); 
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style lang="scss" scoped>
::v-deep .swiper-button-next:after,
      .swiper-button-prev:after {
        display: none;
      }

      .arrow_left {
        width: 22px;
        height: 22px;
        outline: none;
        border: 0;
        position: absolute;
        left: 1000px;
        bottom: -255px;
      }
      .videoL {
        left:100px;
        bottom:-780px;
      }
      
      .arrow_right {
        width: 22px;
        height: 22px;
        outline: none;
        border: 0;
        position: absolute;
        right: 220px;
        bottom: -255px;
      }
      .videoR {
        right:1140px;
        bottom:-780px;
      }

.partnerImgTop {
  // padding:20px 25px;
  // border:1px solid #d6d6e2;
  height: 145px;
  width:100%;
  float:left;
  position:relative;
  background: #e5e5ea;
  .partnerImg{
    // width:100px;
    display: block;
    // margin: 50px auto;
  }
  .hide{
    display: none;
  }

  &:hover{
   .show{
    display: none;
   }
   .hide{
    display: block;
   }

  }
}
.imgColor {
  background: #d6d6e2;
}
::v-deep .el-collapse-item__wrap {
  background-color: #272a36;
  
}
::v-deep .el-collapse-item__header {
  background-color: #272a36;
  
}

.desFifth {
  padding:0 0 50px 0;font-size:13px;
  letter-spacing: 1px;
  color: #d2d2d2;
}
.blockFifth {
  height: 40px;
  width:100%;
  .titFifth {
    font-size:16px;display:block;float:left;
    color:#d2d2d2;
  }
  .dateFifth {
    font-size:12px;display:block;float:right;
     color:#d2d2d2;
  }
}
.el-collapse-item__header {
  padding:30px 0
}
.leftFifth {
  .dateStyle {
    padding:20px 0 0 0;
    height: 100%;
    width:140px;
    float: left;
    text-align: center;
    span{
      display: block;
    }
    span.big{
      font-size:60px;
      font-weight: 700;
      height: 50px;
    }
    span.small{
      font-size: 16px;
      
    }
    
  }
}

.fifthNews {
      height: 100%;
      width:550px;
      float: left;
      span.title{
        display: block;
        font-size:20px;
        height:40px;
        line-height: 30px;
        border-bottom: 1px solid #99a9bf;
      }
      span.content{
        display: block;
        font-size: 12px;
        height:28px;
        line-height: 28px;
        letter-spacing: 1px;
      }
    }
.titleStyle {
  height:100%;display:inline-block;color: #fff;
}
.subTitleStyle {
  position:relative;display:inline-block;width:410px;height:95px;border-bottom:1px solid #3f4354;margin-left:10px;margin-top:40px;
}
.logoContain{
  // text-align: center;
  position: relative;
  width: 33%;
  height: 100%;
  float:left;
  .logoTit{
    font-size:62px;
    color:#272a36;
    display: block;
    letter-spacing: 1px;
    font-weight: 700;
    position:absolute;
    top:100px;
  }
  .logoWord {
    font-size: 16px;
    font-weight: 300;
    color:#272a36;
    display: block;
    position: absolute;
    bottom: 40px;
  }
}
.clearBoth {
  clear: both;
  line-height: 0;
  height: 0;
}
.wordsOne{
  position:absolute;
  right:140px;
  top:440px;
  z-index: 4;
  span {
    font-weight: 100;
    display: block;
    text-align: right;
    line-height: 35px;
    color: #e9e9ea;
    letter-spacing: 1px;
  }
}
.el-carousel__item image {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    display: block;
    width: 100%;
    line-height: 550px;
    height: 550px;
    margin: 0;
  }
.bg { background:url('./images/bgEquipment.png') no-repeat center/cover padding-box content-box;width:100%;height:100%}
.bgThird {background: url('./images/videoBg.png') no-repeat center/cover padding-box content-box;height: 900px;}



.carouselStyle {
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 30px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    // background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    // background-color: #d3dce6;
  }
  .carousel-card {  
  display: flex;  
  flex-direction: column;  
  // align-items: center;  
  // justify-content: center;  
  width: 100%; /* 或者设置一个具体的宽度 */  
  height: 100%; /* 与 carousel 的 height 属性保持一致 */  
  box-sizing: border-box;  
  padding: 16px;  
  // background-color: #fff;  
  border-radius: 8px;  
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  
}  
  
.carousel-card__image {  
  width: 100%;  
  // max-height: 100px; /* 根据需要调整图片高度 */  
  object-fit: cover;  
  border-radius: 8px 8px 0 0;  
}  
  
.carousel-card__content {  
  text-align: left;  
  float: left;
  padding: 26px 0;  
}  
  
.carousel-card__title {  
  font-size: 1.25em;  
  margin-bottom: 8px;  
}  
  
.carousel-card__description {  
  font-size: 0.875em;  
  color: #555;  
}  
  
/* 覆盖 Element Plus 的默认样式以显示两个项目 */  
.el-carousel__item {  
  display: flex;  
  justify-content: center;  
  width: 80%; /* 因为我们要显示两个项目，所以每个项目占 50% 的宽度 */  
  transition: transform 0.5s ease;  
}  
  
.el-carousel {  
  // display: flex;  
  // overflow: hidden;  
  // width: 80%; /* 或者设置一个具体的宽度 */  
}  
  
/* 重要的是要设置 .el-carousel__container 的宽度为两倍的项目宽度，以便容纳两个项目 */  
.el-carousel__container {  
  // width: 200%; /* 2 * 100% (每个项目的宽度) */  
}  
  
/* 可选：隐藏或自定义箭头和指示器 */  
.el-carousel__arrow {  
  /* 如果需要，可以自定义箭头的样式 */  
}  
  
.el-carousel__indicator {  
  display: none; /* 如果不需要指示器，可以将其隐藏 */  
}  
}

::v-deep .el-carousel__container img {
  // height:100%;
  // width:auto;
  margin: 0 auto;
  display: block;
}


.allLogo img {  
  transition: transform 0.5s; /* 设置过渡效果，使放大效果更平滑 */  
}  
  
.allLogo img:hover {  
  transform: scale(1.2); /* 鼠标悬停时图片放大1.2倍 */  
}

// .carousel-item {  
//   height: 100%; /* 确保子元素高度为 100% */  
//   background-size: cover;  
//   background-position: center;  
// }  
</style>
